import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const jiraBusinessTimelineRoute: InvariantJiraRoute = {
	name: 'classic-business-timeline',
	path: '/jira/core/projects/:projectKey/timeline/:viewId?',
	exact: true,
};
